import {
  NotificationTemplateInput,
  NotificationTemplateValueDto,
} from "gql/graphql";
import { extractLocalizedValue } from "@/shared/form/localized-value/utils/extract-localized-value";

export function notificationTemplateValueDtoToNotificationTemplateInput(
  input?: NotificationTemplateValueDto,
): NotificationTemplateInput {
  return {
    title: extractLocalizedValue(input?.title),
    body: extractLocalizedValue(input?.body),
    prettyBody: {
      html: extractLocalizedValue(input?.prettyBody?.html),
      templateData: extractLocalizedValue(input?.prettyBody?.templateData),
    },
  };
}
